export const authenticationSessionsSudoEndpointPath = '/api/v2/authentication-sessions/sudo'
